module.exports = __webpack_public_path__ + "img/NecroticBoneResorbed.96cba84a.jpg";